<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Daftar Edit IMEI</h5>
            </template>

            <b-row class="mb-3">
                <b-col cols="12" md="6">
                    <b-form-group label="No. Faktur">
                        <b-form-input
                            v-model="filters.noFaktur"
                            id="filterInput"
                            type="search"
                            placeholder="Masukkan No. Faktur"
                            @keyup.enter="onSearch()"
                        />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group label="No. IMEI / SN">
                        <b-form-input
                            v-model="filters.imei"
                            id="filterInput"
                            type="search"
                            placeholder="Masukkan No. IMEI / SN"
                            @keyup.enter="onSearch()"
                        />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="12" lg="6">
                    <b-form-group label="Tanggal">
                        <div class="d-flex" :class="isMobile ? 'flex-wrap' : ''">
                            <b-form-input
                                v-model="filters.startDate"
                                name="filterFromDate"
                                id="filterDate"
                                type="date"
                                class="flex-fill"
                            ></b-form-input>
                            <span class="ml-2 mr-2 d-flex align-items-center">s/d</span>
                            <b-form-input 
                                v-model="filters.endDate"
                                name="filterToDate"
                                type="date"
                                class="flex-fill"
                                :min="filters.startDate"
                            ></b-form-input>
                        </div>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="12">
                    <div class="wrapper-button-filter-daftar-edit-imei">
                        <b-button variant="pgiBtn" :disabled="isBusy" @click="onSearch()"> 
                        Search
                        </b-button>
                        <b-button variant="pgiBtn" :disabled="isBusy" @click="onReset()">Reset</b-button>
                        <b-button variant="pgiBtn" @click="confirmDownloadExcel()">
                            <i class="fa fa-download mr-2"></i>
                            Download Excel
                        </b-button>
                    </div>
                </b-col>
            </b-row>

            <div class="detail-data-wrapper">
                <b-table bordered hover show-empty 
                    :busy="isBusy" 
                    :items="data"
                    :no-local-sorting="false" 
                    :fields="fieldsDesktop"
                    responsive class="mb-3">
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading data...</strong>
                        </div>
                    </template>
                    <template v-slot:empty>
                        Tidak ada data perubahan imei.
                    </template>
                    <template v-slot:cell(perubahan)="row">
                        <p class="mb-0">Diubah oleh {{row.item.createdBy}}</p>
                        <p class="mb-0 smallText text-muted">NF {{row.item.noFaktur}}</p>
                        <p class="mb-0 smallText text-muted">{{$helper.changeDateFormat(row.item.tglEdit)}} {{$helper.changeDateFormatGetHour(row.item.tglEdit)}}</p>
                    </template>
                    <template v-slot:cell(barang)="row">
                        <p class="mb-0">{{row.item.barangMerk}} - {{row.item.barangTipe}}</p>
                        <p class="mb-0 smallText text-muted">{{row.item.barangJenis}}</p>
                    </template>
                    <template v-slot:cell(imei)="row">
                        <p class="mb-0 text-muted">{{ row.item.imeiSebelum }}</p>
                        <div style="margin-left: 60px;">
                            <i class="fa fa-arrow-down text-muted"></i>
                        </div>
                        <p class="mb-0">{{ row.item.imeiSesudah }}</p>
                    </template>
                </b-table>

                <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                    <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                        <b-form-select v-model="show" @change="onLimitChange" :options="optionsLimit">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled />
                            </template>
                        </b-form-select>
                        <span class="ml-2">{{ totalViewText }}</span>
                    </b-input-group>
                    <b-pagination class="mb-0"
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        aria-controls="my-table"
                        @input="onPageChange"
                    ></b-pagination>
                </div>
            </div>
         </b-card>

        <ModalConfirm id="modal-confirm-excel" title="Konfirmasi Download Excel" :isSubmitting="isLoadingExcel" desc="Apakah Anda yakin ingin mendownload daftar edit IMEI dalam format Excel?" @submit="openModalDownloadExcel" />

        <b-modal id="modal-download-excel" centered title="Download Excel" hide-footer no-close-on-backdrop>
            <div class="show-btn-download">
                <p class="">
                    Silakan download dengan klik tombol dibawah ini :
                </p>
                <b-button variant="pgiBtn" class="mb-0 download-btn">
                    <a v-bind:href="$baseFilePath + filePathDownload" download>
                        <i class="fa fa-download mr-2"></i>
                        Download Excel
                    </a>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import CONSTANTS from '@/constants'

export default {
    name: 'daftar-edit-imei',
    data() {
        return {
            initStatus: 0,
            isBusy: true,
            data: [],
            filters: {
                noFaktur: '',
                imei: '',
                startDate: null,
                endDate: null,
            },
            fieldsDesktop: [
                { key: "perubahan", label: "Informasi Perubahan" },
                { key: "barang", label: "Barang" },
                { key: "imei", label: "IMEI" },
            ],
            fieldsMobile: [
                { key: "detail", label: "Detail" },
            ],
            currentPage: 1,
            show: 10,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,
            totalViewText: "",
            optionsLimit: CONSTANTS.OPTIONS_LIMIT_PAGINATION,
            isMobile: false,
            filePathDownload: '',
            isLoadingExcel: false,
        }
    },
    methods: {
        async init() {
            this.initStatus = 0
            try {
                await this.getItems()
                this.initStatus = 1
            } catch (error) {
                this.$helper.parseError(this, error)
                this.initStatus = -1
            }
        },
        onSearch() {
            this.getItems();
        },
        onReset() {
            this.filters = {
                noFaktur: '',
                imei: '',
                startDate: null,
                endDate: null,
            }

            this.getItems();
        },
        handleResize() {
            this.isMobile = window.innerWidth <= 576;
        },
        getItems(page = 1) {
            this.isBusy = true
            this.data = []
            this.currentPage = isNaN(page) ? 1 : page

            const params = {
                page: this.currentPage - 1,
                size: this.perPage,
            }

            if (!this.$helper.isNullOrEmpty(this.filters.noFaktur)) {
                params.noFaktur = this.filters.noFaktur;
            }

            if (!this.$helper.isNullOrEmpty(this.filters.imei)) {
                params.imei = this.filters.imei;
            }

            if (!this.$helper.isNullOrEmpty(this.filters.startDate)) {
                params.startDate = this.filters.startDate;
            }

            if (!this.$helper.isNullOrEmpty(this.filters.endDate)) {
                params.endDate = this.filters.endDate;
            }

            return this.$axios.get("gadai/get-edit-imei", {
                params,
            }).then(res => {

                this.data = res.data.content
                this.totalRows = res.data.totalElements

                let pg = this.currentPage - 1

                let prev = pg * this.show + 1
                let limit = pg * this.show + this.show
                if (limit > this.totalRows) limit = this.totalRows

                this.totalViewText = "Menampilkan "+ prev + " - " + limit + " dari " + this.totalRows + " entri"
            }).catch(error => {
                this.$helper.parseError(this, error)
                throw error
            })
            .finally(() => {
                this.isBusy = false
            })
        },
        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems()
        },
        onPageChange(newPage) {
            this.getItems(newPage)
        },
        confirmDownloadExcel() {
            this.filePathDownload = '';
            this.$bvModal.show("modal-confirm-excel")
        },
        openModalDownloadExcel() {
            const isValid = this.validateTanggal();
            if (!isValid) {
                this.$helper.toastErr(this, 'Tanggal sampai tidak boleh lebih kecil dari tanggal mulai');
                return;
            }

            this.isLoadingExcel = true;
            const params = {
                startDate: this.filters.startDate,
                endDate: this.filters.endDate,
            }

            if (!this.$helper.isNullOrEmpty(this.filters.noFaktur)) {
                params.noFaktur = this.filters.noFaktur;
            }

            if (!this.$helper.isNullOrEmpty(this.filters.imei)) {
                params.imei = this.filters.imei;
            }

            this.$axios.get("gadai/generate-excel-edit-imei", {
                params,
            }).then(res => {
                this.filePathDownload = res.data.name
                this.$bvModal.show("modal-download-excel")
                this.$bvModal.hide("modal-confirm-excel")
            }).catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isLoadingExcel = false;
            })
        },
        validateTanggal() {
            const { startDate, endDate } = this.filters;
            
            if (startDate && endDate) {
                const start = new Date(startDate);
                const end = new Date(endDate);

                if (end < start) {
                    return false;
                }
            }
            return true;
        }
    },
    created() {
        this.init();
    },
    mounted() {
        this.handleResize();
        window.addEventListener("resize", this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
    }
}
</script>

<style scoped>
.wrapper-button-filter-daftar-edit-imei {
    display: flex;
    flex-wrap: wrap;
    gap: 8px !important;
}
</style>
